
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class LiveBadge extends Vue {
  @Prop({default: "sm"}) public size?: string;
}
